<script lang="ts">
	import type { DatasheetPoiData } from '../types';
	import Image from '$lib/components/atoms/image/Image.svelte';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';
	import { getSponsorConfigByPoi, isAnyPoiPartner } from '$lib/constants/sponsoredPoi';
	import DatasheetDetail from './detail/DatasheetDetail.svelte';
	import DatasheetHighlight from './highlight/DatasheetHighlight.svelte';

	interface Props {
		poi: DatasheetPoiData;
		isCollapsed: boolean;
		datasheetHighlightContainer: HTMLDivElement | undefined;
		onSeeOnMap?: () => void;
		onItineraryClick?: () => void;
		onLearnMoreClick?: () => void;
		onHandleClick?: () => void;
	}

	let {
		poi,
		isCollapsed,
		datasheetHighlightContainer = $bindable(),
		onSeeOnMap,
		onItineraryClick,
		onLearnMoreClick,
		onHandleClick,
	}: Props = $props();

	const brandLogoUrl = $derived(isAnyPoiPartner(poi) ? getSponsorConfigByPoi(poi)?.datasheet.brandLogoUrl : undefined);
	const removeHightEmptyContainerClasses = $derived(isAnyPoiPartner(poi) ? 'absolute' : '');
</script>

<button
	type="button"
	class="snap-handle py-2 rd-2 b-0 flex justify-self-center justify-center bg-transparent md:hidden"
	aria-label="Toggle datasheet"
	onclick={() => onHandleClick?.()}
	onpointerdown={e => e.preventDefault()}
>
	<span class="rd-1 w-8 h-1 bg-base-15"></span>
</button>
<div class="flex items-start justify-between md:mt-4 relative">
	<div
		class="snap-end clamp-lines-2 text-title px-2"
		data-testId="datasheet-title"
		class:mr-18={isAnyPoiPartner(poi) && brandLogoUrl}
	>
		{poi.name}
	</div>
	{#if isAnyPoiPartner(poi) && brandLogoUrl}
		<Image src={brandLogoUrl} class="w-16 ml-1 top--4 absolute right-1" alt={poi.name || ''} />
	{/if}
	{#if poi.__typename === 'AccommodationPOI' && poi.stars !== null}
		<div class="flex text-5 text-hotel h-8 items-center">
			<RepeatIcons icon="grade" amount={poi.stars} style="grade" />
		</div>
	{/if}
</div>
<div class={['flex flex-col w-full gap-6 mb-6', poi.__typename === 'ServiceRestStopPOI' && poi.facilities && poi.facilities.length > 0 ? '' : 'px-2']}>
	<div
		class={removeHightEmptyContainerClasses}
		bind:this={datasheetHighlightContainer}
	>
		<DatasheetHighlight displayPicture={isCollapsed} {poi} />
	</div>
	<div class="flex flex-col gap-6 snap-map-button">
		<DatasheetDetail {poi} {onSeeOnMap} {onItineraryClick} {onLearnMoreClick} />
	</div>
</div>

<style>
	.snap-handle {
		scroll-snap-align: start;
	}

	.snap-map-button {
		scroll-snap-align: start;
		scroll-margin: 68px;
	}
</style>
